<template>
  <div class="homepage" />
</template>
<script>

export default {
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
    if (this.$auth.loggedIn) {
      this.$router.replace('/decks')
    } else {
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.homepage {
  min-height: 100vh;
  background-color: #fff;
}
</style>
